'use strict';

module.exports = String.fromCharCode;